import styled from 'styled-components';
import { COLORS } from '../../constants/style/color';
import { getRgbaValue, rem } from '../../utils/style';

export const MaterialTimePickerWrapper = styled.div`
  position: relative;
  width: 100%;

  .time-picker-input {
    width: 100%;
    background-color: ${COLORS.White};
    border: ${rem(1)} solid ${COLORS.LightGray};
    border-radius: ${rem(6)};
    padding: ${rem(11)} ${rem(12)};
    -webkit-appearance: none;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: ${rem(40)};
    height: ${rem(40)};

    font-weight: 400;
    font-size: ${rem(15)};
    line-height: ${rem(16)};

    filter: drop-shadow(${rem(0)} ${rem(2)} ${rem(4)} ${getRgbaValue(`${COLORS.Gray400}`, '0.2')});
    transition: all 0.2s 0s ease;

    &:hover,
    &:focus {
      border: ${rem(1)} solid ${COLORS.Blue};
      outline: none;
    }

    &.is-invalid {
      border: ${rem(1)} solid ${COLORS.Red};
    }

    &.disabled {
      background-color: ${COLORS.OffWhite};
      border: ${rem(1)} solid ${COLORS.LightGray};
      cursor: not-allowed;
    }

    .time-display {
      color: ${COLORS.Gray};
      flex: 1;
    }

    .time-icons {
      display: flex;
      align-items: center;
      gap: ${rem(4)};
      padding-right: ${rem(4)};
    }

    .time-clear-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${COLORS.Gray};
      font-size: ${rem(20)};
      cursor: pointer;
      transition: color 0.2s ease;
      padding: ${rem(4)};
      
      &:hover {
        color: ${COLORS.Black};
      }
    }
  }

  .time-picker-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: ${COLORS.White};
    border: ${rem(1)} solid ${COLORS.CulturedWhite};
    border-radius: ${rem(8)};
    box-shadow: 0 ${rem(10)} ${rem(25)} rgba(0, 0, 0, 0.15);
    z-index: 1000;
    margin-top: ${rem(4)};
    min-width: ${rem(250)};
    max-width: ${rem(280)};
  }

  .time-picker-header {
    padding: ${rem(8)} ${rem(12)};
    border-bottom: ${rem(1)} solid ${COLORS.CulturedWhite};
    font-weight: 500;
    font-size: ${rem(13)};
    color: ${COLORS.Gray};
  }

  .time-picker-content {
    padding: ${rem(8)};
  }

  .time-columns {
    display: flex;
    gap: ${rem(8)};
  }

  .time-column {
    flex: 1;
    min-width: ${rem(60)};
  }

  .column-header {
    font-size: ${rem(11)};
    font-weight: 500;
    color: ${COLORS.Gray};
    margin-bottom: ${rem(4)};
    text-align: center;
  }

  .time-options {
    max-height: ${rem(120)};
    overflow-y: auto;
    border: ${rem(1)} solid ${COLORS.LightGray};
    border-radius: ${rem(4)};
  }

  .time-option {
    padding: ${rem(4)} ${rem(8)};
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-size: ${rem(12)};
    border-bottom: ${rem(1)} solid ${COLORS.OffWhite};

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: ${COLORS.OffWhite};
    }

    &.selected {
      background-color: ${COLORS.Purple};
      color: ${COLORS.White};
      font-weight: 500;

      &:hover {
        background-color: ${COLORS.DarkPurple};
      }
    }

    &.disabled {
      opacity: 0.4;
      cursor: not-allowed;
      color: ${COLORS.SpanishGray};
      text-decoration: line-through;

      &:hover {
        background-color: transparent;
      }

      &.selected {
        background-color: ${COLORS.LightGray};
        color: ${COLORS.SpanishGray};
      }
    }
  }

  .time-picker-footer {
    padding: ${rem(8)} ${rem(12)};
    border-top: ${rem(1)} solid ${COLORS.CulturedWhite};
    display: flex;
    justify-content: flex-end;
    gap: ${rem(6)};
  }

  .cancel-btn {
    background: transparent;
    border: ${rem(1)} solid ${COLORS.LightGray};
    color: ${COLORS.Gray};
    border-radius: ${rem(4)};
    padding: ${rem(6)} ${rem(12)};
    font-size: ${rem(12)};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${COLORS.OffWhite};
    }
  }

  .ok-btn {
    background-color: ${COLORS.Purple};
    color: ${COLORS.White};
    border: none;
    border-radius: ${rem(4)};
    padding: ${rem(6)} ${rem(12)};
    font-size: ${rem(12)};
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${COLORS.DarkPurple};
    }

    &:active {
      transform: translateY(${rem(1)});
    }
  }

  /* Custom scrollbar */
  .time-options::-webkit-scrollbar {
    width: ${rem(6)};
  }

  .time-options::-webkit-scrollbar-track {
    background: ${COLORS.OffWhite};
    border-radius: ${rem(3)};
  }

  .time-options::-webkit-scrollbar-thumb {
    background: ${COLORS.SpanishGray};
    border-radius: ${rem(3)};

    &:hover {
      background: ${COLORS.Silver};
    }
  }
`;
